export const DATE_FORMATS = [
  'MM.DD.YYYY',
  'DD.MM.YYYY',
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'YYYY-MM-DD',
];

export const TIME_FORMATS = [
  'HH:mm',
  'HH:mm:ss',
  'hh:mm:ss A',
];

export const DEFAULT_DATE_FORMAT = 'MM.DD.YYYY';
